import { IResults, IErrorType, } from '../state-helpers/search-results';
import * as actions from '../actions/index';
import * as _ from 'lodash';

const defaultResultsModel = Object.freeze({
    searchItemList: [],
    facets: [],
    loading: false,
    currentPage: 1,
    errorMessage: '',
    totalNumber: 0,
    totalPages: 0,
    showResults: true,
    trackingId: '',
    errorType: IErrorType.NONE,
    suggestion: '',
    fromAutocomplete: false
});


export function resultsModel(state: IResults, action: actions.IResultsLoadedAction): IResults {
    if (typeof state === 'undefined') {
        state = defaultResultsModel
    }

    switch (action.type) {
        case actions.ActionType.SET_PAGE:
            return _.assign({}, state, { loading: false });
        case actions.ActionType.RESULTS_LOADING:
            return _.assign({}, state, { loading: action.isLoading });
        case actions.ActionType.SHOW_RESULTS:
            return _.assign({}, state, { showResults: action.showResults });
        case actions.ActionType.SET_SORT:
            return _.assign({}, state, { loading: true });
        case actions.ActionType.SET_CONTEXT:
            return _.assign({}, state, { loading: true });
        case actions.ActionType.SET_PAGE:
            return _.assign({}, state, { loading: true });
        case actions.ActionType.RESULTS_LOADED:
            return _.assign({}, state, {
                loading: false,
                searchItemList: action.results,
                facets: action.facets,
                totalNumber: action.totalNumber,
                totalPages: action.totalPages,
                errorMessage: '',
                errorType: IErrorType.NONE,
                trackingId: action.trackingId,
                suggestion: action.suggestion,
                fromAutocomplete: action.fromAutocomplete
            });
        case actions.ActionType.RESULTS_LOAD_FAILURE:
            return _.assign({}, state, {
                loading: false,
                errorMessage: action.errorMessage,
                errorType: action.errorType,
                searchItemList: [],
                facets: [],
                totalNumber: 0,
                totalPages: 0,
                trackingId: '',
                suggestion: '',
                fromAutocomplete: false
            });
        case actions.ActionType.CLEAR_ERROR_TEXT:
            return _.assign({}, state, { errorMessage: '', errorType: IErrorType.NONE });
        case actions.ActionType.BROWSER_NAVIGATION:
            return _.assign({}, state, {
                currentPage: action.page,
                loading: true
            });
        default:
            return state;
    }
}

export function getIconType(type: string) {
    if (type == "Audio") {
        return 'icon-Icon_Audio';
    }
    else if (type == "Video") {
        return 'icon-Icon_Video';
    }
    else return null;
}